import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Toast } from "utils/toast";
import ErrorMessage from "component/common/ErrroMessage";
import { endpoints } from "config/api";
import { fileType, splitFileName } from "utils/helper";
import axios from "axios";
import close from "assets/images/close.svg";
import defaultImg from "assets/images/product-img.svg";

import styles from "./FileUpload.module.scss";

const FileUpload = ({ label, color, onChange, error, msg }) => {
  let [uploadFile, setUploadFile] = useState([]);

  let [fileUrl, setFileUrl] = useState([]);

  let [, setState] = useState();

  const getImages = async (event) => {
    event.persist();
    await updateFileName(event, false);
    onUpload(event.target.files);
  };

  const onDropImage = async (acceptedFiles) => {
    await updateFileName(acceptedFiles, true);
    onUpload(acceptedFiles);
  };

  const updateFileName = (event, isDropZone) => {
    if (isDropZone) {
      let fileInfo = uploadFile;
      event.map((list, index) => {
        fileInfo.push({ name: list.name, percentage: 0, hide: false });
      });
      setUploadFile(fileInfo);
    } else {
      let fileInfo = uploadFile;
      for (const file of event.target.files) {
        fileInfo.push({ name: file.name, percentage: 0, hide: false });
      }
      setUploadFile(fileInfo);
    }
  };

  const onUpload = async (event) => {
    let formData = new FormData();
    for (let index = 0; index < event.length; index++) {
      const file = event[index];
      formData.append("file", file);
    }
    let files = fileUrl;
    try {
      let response = await fileUpload(formData);
      if (response.status == 200) {
        response.data.data.map((item, index) => {
          files.push(item.url);
        });
        let images = files.filter((url) => {
          return fileType(url) !== "mp4";
        });
        let videos = files.filter((url) => {
          return fileType(url) === "mp4";
        });
        let hideProgress = uploadFile;
        hideProgress.map((list, index) => {
          list.hide = true;
          setState(Math.random());
        });
        onChange(images.concat(videos));
        setFileUrl(files);
        setUploadFile(hideProgress);
        setState(Math.random());
      }
    } catch (error) {
      Toast({ type: error, message: error.data.message });
    }
  };

  const fileUpload = async (file) => {
    let request = await axios({
      method: "POST",
      url: endpoints.common.MULTIPLE_FILE_UPLOAD,
      data: file,
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percentCompleted = Math.round((loaded * 100) / total);
        let progess = uploadFile;
        progess.map((list, index) => {
          list.percentage = percentCompleted;
          setState(Math.random());
        });
        setUploadFile(progess);
      },
    });
    return request;
  };

  const onDelete = (index) => {
    let newFileUrl = fileUrl;
    let newUploadFile = uploadFile;
    newFileUrl.splice(index, 1);
    newUploadFile.splice(index, 1);
    setFileUrl(newFileUrl);
    setUploadFile(newUploadFile);
    setState(Math.random());
    onChange(newFileUrl);
  };

  return (
    <>
      <label style={{ color: color }}>{label}</label>
      <Dropzone onDrop={onDropImage}>
        {({ getRootProps, getInputProps }) => (
          <div className={styles.file_upload} {...getRootProps()}>
            <span>DRAG FILES HERE OR</span>
            <label className={styles.file_upload_label}>BROWSE</label>
            <input
              {...getInputProps()}
              type="file"
              className={styles.file_upload_input}
              onChange={getImages}
              accept="image/png, image/jpeg, image/jpg, video/mp4"
            />
          </div>
        )}
      </Dropzone>
      <ErrorMessage
        error={error}
        message={{
          required: msg,
        }}
      />
      <div className={styles.file_list}>
        {uploadFile.map((list, index) => {
          return (
            <div className={styles.file_card} key={index}>
              {fileType(fileUrl[index]) == "mp4" ? (
                <video>
                  <source src={`${fileUrl[index]}#t=5`} type="video/mp4" />
                </video>
              ) : (
                <img src={fileUrl[index] ? fileUrl[index] : defaultImg} />
              )}
              <div className="d-flex flex-column justify-content-center w-100 position-relative">
                <span>{list?.name}</span>
                {!list.hide && (
                  <div className={styles.progress_bar}>
                    <div
                      className={styles.progess_percent}
                      style={{
                        width: `${list?.percentage ? list.percentage : 0}%`,
                      }}
                    ></div>
                  </div>
                )}
                <div
                  className={styles.close_icon}
                  onClick={() => onDelete(index)}
                >
                  <img src={close} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FileUpload;
